<template>
    <div>
        <b-card>
            <b-overlay
              :show="processing"
              spinner-variant="primary"
              spinner-type="grow"
              spinner
              rounded="sm"
            >
            <div class="excel-import">
              <input type="file" ref="fileInput" class="hidden" accept=".jpg, .jpeg" @change="handleClick">
              <div
                @click="$refs.fileInput.click()"
                @drop="handleDrop"
                @dragover="handleDragover"
                @dragenter="handleDragover"
                class="p-3 mb-1 cursor-pointer text-center auto-suggest-suggestions-list ">
                <feather-icon icon="UploadCloudIcon" style="height:4rem !important;width:4rem !important;" svgClasses="stroke-current text-grey" /><br>
                <span> Drop Photo or </span>
                <span class="font-medium text-primary" @click.stop="$refs.fileInput.click()">Browse</span>
                <!-- <vs-button type="border" @click.stop="$refs.fileInput.click()">Browse</vs-button> -->
              </div>
            </div>
          </b-overlay>

        </b-card>
      <b-card>
      <b-form
        ref="form"
        class="repeater-form"
      >
      <div>顯示次序為 : 最大重量(Weight) > 上載次序DESC<br><br></div>
        <!-- Row Loop -->
        <b-row
          v-for="(item, index) in sliders"
          :id="item.id"
          :key="item.id"
          ref="row"
        >
          <!-- Item Name -->

          <b-col md="2">
           <b-img :src="item.slider" style="width:100%"/>
          </b-col>

          <!-- Cost -->


          <!-- Quantity -->
          <b-col md="2">
            <b-form-group
              label="From"
              label-for="from"
            >
              <b-form-input
                id="from"
                type="text"
                v-model="item.start_at"
                placeholder="from"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group
              label="Expire"
              label-for="expire"
            >
              <b-form-input
                id="expire"
                type="text"
                v-model="item.expire_at"
                placeholder="expire"
              />
            </b-form-group>
          </b-col>
          <b-col md="1">
            <b-form-group
              label="Weight"
              label-for="weight"
            >
              <b-form-input
                id="weight"
                type="text"
                v-model="item.weight"
                placeholder="weight"
              />
            </b-form-group>
          </b-col>
          <!-- Profession -->


          <!-- Remove Button -->
          <b-col
            lg="1"
            md="1"
            class="mr-2 text-right"
          >
        <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="primary"
              class="mt-0 mt-md-2 mr-2"
              @click="updateItem(item)"
            >

              <span>Update</span>
            </b-button>


          </b-col>
          <b-col
            lg="1"
            md="1"
            class="mb-50 text-right"
          >
  <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-danger"
              class="mt-0 mt-md-2 mr-2"
              @click="removeItem(item.id)"
            >

              <span>Delete</span>
            </b-button>


          </b-col>
          <b-col cols="12">
            <hr>
          </b-col>
        </b-row>

      </b-form>

  </b-card>
  </div>
</template>

<script>
  import ImportSlider from '@core/components/excel/ImportSlider.vue'
import { BForm, BFormGroup, BImg, BFormInput, BRow, BCol, BOverlay,BButton,BCard,BFormCheckbox } from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import { heightTransition } from '@core/mixins/ui/transition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
export default {
  components: {
    BCardCode,
    BImg,
    ImportSlider,
    BOverlay,
    BForm,
    BCard,
    BFormCheckbox,
    vSelect,
    BRow,
    BCol,
    ToastificationContent,
    BButton,
    BFormGroup,
    BFormInput,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
        processing: false,
        product_status:'Active',
        searchString: null,
        form : {
            center_id : this.$store.getters['center/currentCenterId'],
            products : []
        },
        sliders: [],
      nextTodoId: 3,
    }
  },
  mounted() {
    this.initTrHeight()
  },
  watch: {
    product_status: {
      handler(newValue, oldValue) {
        this.get_products()
      }
    },
    searchString: {
      handler(newValue, oldValue) {
        this.get_products()
      }
    },
  },
  created() {
    this.get_sliders()
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {

      get_sliders() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/sliders/`)
        .then(res => {
          this.sliders = res.data.sliders
          this.nextTodoId = res.data.length + 1
           this.initTrHeight()
        })
    },
    
    removeItem(id) {
        this.$http.post(process.env.VUE_APP_API_BASE+'/sliders/delete/',{ id : id })
              .then(res => {
                if (res.data.result === true) {
                    this.get_sliders()
                  this.processing = false
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                      title: 'Success',
                      icon: 'CheckIcon',
                      variant: 'success',
                      text: res.data.message,
                    },
                    })
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                      title: 'Error',
                      icon: 'XIcon',
                      variant: 'danger',
                      text: res.data.message,
                    },
                  })
                  this.processing = false
                }
            })
    },
    updateItem(item) {
        this.$http.post(process.env.VUE_APP_API_BASE+'/sliders/update/', item )
              .then(res => {
                if (res.data.result === true) {
                    this.get_sliders()
                  this.processing = false
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                      title: 'Success',
                      icon: 'CheckIcon',
                      variant: 'success',
                      text: res.data.message,
                    },
                    })
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                      title: 'Error',
                      icon: 'XIcon',
                      variant: 'danger',
                      text: res.data.message,
                    },
                  })
                  this.processing = false
                }
            })
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
    handleDragover (e) {
        e.stopPropagation()
        e.preventDefault()
        e.dataTransfer.dropEffect = 'copy'
      },
      handleDrop (e) {
        e.stopPropagation()
        e.preventDefault()
        const files = e.dataTransfer.files
        if (files.length !== 1) {
          this.$vs.notify({
            title: 'Login Attempt',
            text: 'Only support uploading one file!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
          return
        }
        const rawFile = files[0] // only use files[0]

        this.uploadFile(rawFile)
      },
      readerData (rawFile) {
        this.processing = true
        var file = rawFile
        if (file.size > 1024 * 1024) { 
            this.$toast({
            component: ToastificationContent,
            position: 'top-center',
            props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: 'The uploaded file exceeds the size limit of 1MB.',
            },
            });
            this.processing = false;
            return false;
        }
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              console.log( reader.result )
              this.$http.post(process.env.VUE_APP_API_BASE+'/sliders/add/',{ base64 : reader.result })
              .then(res => {
                if (res.data.result === true) {
                    this.get_sliders()
                  this.processing = false
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                      title: 'Success',
                      icon: 'CheckIcon',
                      variant: 'success',
                      text: res.data.message,
                    },
                    })
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                      title: 'Error',
                      icon: 'XIcon',
                      variant: 'danger',
                      text: res.data.message,
                    },
                  })
                  this.processing = false
                }
              })
            }
            reader.onerror = function (error) {
                console.log('Error: ', error)
                this.processing = false
            }  
          
      },
      handleClick (e) {
        const files = e.target.files
        const rawFile = files[0]
        if (!rawFile) return
        this.uploadFile(rawFile)
      },
      async uploadFile (file) {
        this.$refs['fileInput'].value = null // fix can't select the same excel
        this.readerData(file)
      }
  },
}
</script>

<style lang="scss" scoped>
hr {
  margin:0 0 0.5rem 0;
}
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
